"use client";

import { FC } from "react";
import ProductListSectionFullWidth from "./default-fullwidth";
import { VariantProps } from "./default-fullwidth";

const HaiAnhProductListSectionFullWidth: FC<VariantProps> = (props) => (
  <ProductListSectionFullWidth {...props} theme="haianh" />
);

HaiAnhProductListSectionFullWidth.displayName = "HaiAnhProductListSectionFullWidth";

export default HaiAnhProductListSectionFullWidth;
